<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-clipboard-check"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }} #{{ order.orderNumber }}
        </div>
      </template>
      <v-row class="mt-5">
        <v-col
          cols="12"
          md="2"
        >
          <div>
            <v-select
              v-model="order.status"
              :items="orderStateItems"
              item-text="name"
              item-value="code"
              :label="$t('fields.order.status')"
              outlined
              @change="showControls()"
            />
          </div>
        </v-col>
        <v-col
          id="reason"
          style="display: none"
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="order.reason"
            color="secondary"
            :label="$t('fields.order.reason')"
            outlined
          />
        </v-col>
        <v-col
          id="controls"
          style="display: none"
          cols="12"
          md="3"
        >
          <div class="pa-3 text-center">
            <v-btn
              color="warning"
              default
              @click="goToList"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="success"
              default
              :loading="loadingSave"
              @click="submitForm()"
            >
              {{ $t("save") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-card-title>Cliente</v-card-title>
          <v-card-text>
            <div class="my-2 subtitle-1">
              Orden #{{ order.orderNumber }}
            </div>
            <div class="my-2 subtitle-1">
              {{ order.customerName }}
            </div>
            <div class="my-2 subtitle-1">
              Ced: {{ order.customerNip }}
            </div>
            <div class="my-2 subtitle-1">
              Tel: {{ order.customerPhoneNumber }}
            </div>
            <!-- <div>
              Small plates, salads & sandwiches - an intimate setting with 12
              indoor seats plus patio seating.
            </div> -->
          </v-card-text>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-card-title>Envío</v-card-title>
          <v-card-text>
            <div class="my-2 subtitle-1">
              {{ order.shippingMethodDetail }} ${{ order.shippingCost }}
            </div>
            <div class="my-1 subtitle-1">
              {{ order.shippingAddressCity }}
            </div>
            <div class="my-1 subtitle-1">
              {{ order.shippingAddressLine }}
            </div>
            <div class="my-1 subtitle-1">
              {{ order.shippingAddressDetail }}
            </div>
            <div class="my-1 subtitle-1">
              {{ order.shippingAddressCode }}
            </div>
          </v-card-text>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-card-title>Pago</v-card-title>
          <v-card-text>
            <div class="mt-2 subtitle-1">
              {{ order.paymentDetail }}
            </div>
            <div
              v-if="!!order.paymentMethod && order.paymentMethod.code == 'visa'"
              class="mt-0 subtitle-1"
            >
              xxxx-xxxx-xxxx-{{ order.creditCardTerminationNumber }}
            </div>
            <div class="mt-3 subtitle-3">
              Sub Total: ${{ order.subTotal }}
            </div>
            <div class="my-2 subtitle-3">
              Envío: ${{ order.shippingCost }}
            </div>
            <div class="my-2 subtitle-3">
              IVA: ${{ (order.subTotal * order.taxes) / 100 }}
            </div>
            <v-divider class="mt-3" />
            <div class="my-2 subtitle-3">
              Total: ${{ order.total }}
            </div>
          </v-card-text>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
        </v-col>
      </v-row>

      <v-divider />
      <v-data-table
        :headers="localizationHeaders"
        :items="order.orderDetail"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loadingOrder"
      >
        <!-- <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addOrder"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:[`item.status`]="{ item }">
          {{ item.status ? "Activo": "Inactivo" }}
        </template> -->
        <template v-slot:[`item.totalLine`]="{ item }">
          {{ "$" + item.totalLine }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ "$" + item.price }}
        </template>
        <template v-slot:[`item.discount`]="{ item }">
          {{ "$" + item.discount }}
        </template>
        <template v-slot:[`item.imageUrl`]="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1 d-flex d-sm-none"
            fab
            x-small
          >
            <v-icon @click="showDialog(item.imageUrl)">
              mdi-file-image
            </v-icon>
          </v-btn>
          <v-img
            class="d-none d-sm-flex"
            :lazy-src="item.imageUrl"
            max-height="100%"
            max-width="50px"
            :src="item.imageUrl"
            @click="showDialog(item.imageUrl)"
          />
        </template>
      </v-data-table>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="400"
          >
            <v-card>
              <v-img
                :lazy-src="dialogImage"
                :src="dialogImage"
                @click="dialog = false"
              />
            </v-card>
          </v-dialog>
        </div>
      </template>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
// import axios from 'axios'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import { mapState } from 'vuex'
  const ordersRespository = repositoryFactory.get('orders')
  // const gameRaritiesRepository = repositoryFactory.get('gameRarities')
  // const gameLinesRepository = repositoryFactory.get('gameLines')
  // const gameExpansionsRepository = repositoryFactory.get('gameExpansions')
  // const sectionsRepository = repositoryFactory.get('sections')

  export default {
    inject: ['theme'], // ??
    name: 'OrderCancelEdit',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      order: {},
      showErrorMessage: false,
      errorMessage: '',
      loadingOrder: false,
      formAction: null,
      loadingSave: false,
      dialog: false,
      dialogImage: '',
    }),
    computed: {
      ...mapState(['orderStateItems']),
      title () {
        // return this.formAction === 'add' ? this.$t('add-order') : this.$t('modify-order')
        return this.$t('order')
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.orderDetail.detail'),
            value: 'detail',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.imageUrl'),
            value: 'imageUrl',
          },
          {
            text: this.$t('tables.orderDetail.quantity'),
            value: 'quantity',
          },
          {
            text: this.$t('tables.orderDetail.price'),
            value: 'price',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.discount'),
            value: 'discount',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.totalLine'),
            value: 'totalLine',
          },
        ]
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingOrder = true
        var id = this.$route.params.id
        ordersRespository
          .getById(id)
          .then(response => {
            self.loadingOrder = false
            self.order = Object.assign({}, response.data.data)
            console.log(self.order)
          // if (self.order.sections != null) {
          //   self.order.sectionsId = self.order.sections.map((x) => x.id)
          // }
          // if (self.order.orderImage.length > 0) {
          //   self.imagePreview = self.order.orderImage[0].url
          // }
          // if (self.order.gameLineId != null) {
          //   this.getExpansions(self.gameLineId)
          // }
          })
          .catch(err => {
            self.loadingOrder = false
            alert(err)
          })
      }
    // this.getRarities()
    // this.getGames()
    // this.getSections()
    },
    methods: {
      showControls () {
        if (this.order.status.toUpperCase() === 'CANCELADA'.toUpperCase()) {
          document.getElementById('reason').style.display = ''
        } else {
          document.getElementById('reason').style.display = 'none'
        }
        document.getElementById('controls').style.display = ''
      },
      showDialog (url) {
        this.dialog = true
        this.dialogImage = url
      },
      submitForm (scope) {
        var self = this
        if ((this.order.status.toUpperCase() === 'CANCELADA'.toUpperCase()) || (this.order.status.toUpperCase() === 'Despachada'.toUpperCase())) {
          this.order.isActive = false
          this.order.closed = true
          // this.order.isPaymentMade = false        // No se
        }
        var data = { data: this.order }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          ordersRespository
            .updateOrder(data, this.order.id)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = true
            })
        } else {
          console.log(data)
          ordersRespository
            .addOrder(data)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
                self.formAction = 'modify'
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = false
            })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
      },
      // getRarities () {
      //   var self = this
      //   gameRaritiesRepository.get().then(response => {
      //     self.gameRarities = response.data.data
      //   }).catch(err => {
      //     alert(err)
      //   })
      // },
      // getGames () {
      //   var self = this
      //   gameLinesRepository.get().then(response => {
      //     self.gameLines = response.data.data
      //   }).catch(err => {
      //     alert(err)
      //   })
      // },
      // getExpansions () {
      //   var self = this
      //   gameExpansionsRepository.get().then(response => {
      //     self.gameExpansions = response.data.data
      //   }).catch(err => {
      //     alert(err)
      //   })
      // },
      // getSections () {
      //   var self = this
      //   sectionsRepository.get().then(response => {
      //     self.sections = response.data.data
      //   }).catch(err => {
      //     alert(err)
      //   })
      // },
      changeGame (gameId) {
        this.getExpansions(gameId)
        this.order.gameExpansionId = null
      },
      goToList () {
        this.$router.push({ name: 'orders' })
      },
    },
  }
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
</style>
